import { Box } from '@mui/material';
import type { TransactionProcessor } from '../schemas/transaction.transformer';
import TransactionProcessorIcon from './TransactionProcessorIcon';

type TransactionProcessorBadgeProps = {
  processor: TransactionProcessor;
};

const TransactionProcessorBadge = ({
  processor,
}: TransactionProcessorBadgeProps) => (
  <Box
    sx={{
      display: 'inline-flex',
      alignItems: 'center',
      justifyContent: 'center',
      px: 1.25,
      py: 0.75,
      minHeight: 30,
      borderRadius: 1,
      border: '1px solid',
      borderColor: 'divider',
      bgcolor: 'background.paper',
      boxShadow: '0 1px 2px rgba(15, 23, 42, 0.06)',
    }}
  >
    <TransactionProcessorIcon processor={processor} />
  </Box>
);

export default TransactionProcessorBadge;
